import PropTypes from 'prop-types';
import startCase from 'lodash/startCase';
import { memo, useCallback, useState } from 'react';

import { pluralize } from 'shared/functions-ts';

import FormEntity from '../FormEntity';
import { GroupedTableClassNames } from '../types';

export interface ItemPlaceholderProps<I> {
  entityIdKey: string;
  entityLabelKey: string;
  entityTypeKey: string;
  classNames?: GroupedTableClassNames;
  onCreateItem: (entity: I) => Promise<unknown>;
}

const initialValues = {};

const ItemsPlaceholder = <I,>({
  classNames,
  entityIdKey,
  entityLabelKey,
  entityTypeKey,
  onCreateItem,
}: ItemPlaceholderProps<I>) => {
  const [showForm, setShowForm] = useState(false);

  const onToggleShowItemForm = useCallback(() => {
    setShowForm(!showForm);
  }, [showForm]);

  let content = null;

  if (showForm) {
    content = (
      <FormEntity
        entityIdKey={entityIdKey}
        entityLabelKey={entityLabelKey}
        entityTypeKey={entityTypeKey}
        initialValues={initialValues}
        onSubmit={onCreateItem}
        onCancel={onToggleShowItemForm}
      />
    );
  } else {
    const nameLabel = `${startCase(entityTypeKey)}`;

    const text = `No ${pluralize(10, nameLabel)}.`;

    content = (
      <span className="empty-field">
        {translate(text)}&nbsp;
        <a title="add item" onClick={onToggleShowItemForm}>
          {translate(`Add a new ${nameLabel}`)}
        </a>
      </span>
    );
  }

  return (
    <div className={classNames?.itemClassName}>
      <div className={classNames?.itemInlineFormClassName}>{content}</div>
    </div>
  );
};

ItemsPlaceholder.propTypes = {
  entityIdKey: PropTypes.string.isRequired,
  entityLabelKey: PropTypes.string.isRequired,
  entityTypeKey: PropTypes.string.isRequired,
  onCreateItem: PropTypes.func.isRequired,
  classNames: PropTypes.object,
};

// eslint-disable-next-line import/no-default-export
export default memo(ItemsPlaceholder);
